<template>
    <b-container>
      <b-row class="mt-5 pt-5">
        <b-col>
          <b-img class="mb-5" src="/static/images/UCNPC_BLK.png" width="360"></b-img>
          <h1>Thank you {{signedName}}</h1>
          <p>Thank you for your support.</p>

          <p>Get more involved by:</p>
          <ol>
            <li>Following us, the National Park City Foundation, on Twitter at <a target="_blank" href="https://www.twitter.com/NatParkCityFdn">@NatParkCityFdn</a>.</li>
            <li>Signing up to <a href="https://www.nationalparkcity.org/join-us" target="_blank">our newsletter</a>.</li>
            <li>Asking someone else to sign the Charter. <SocialShare :showHeading="false"></SocialShare></li>
          </ol>
          <p><a target="_blank" href="/static/downloads/universal_charter_of_national_park_cities.pdf">Download</a> a PDF of the Universal Charter of National Park Cities.</p>
        </b-col>
      </b-row>
      <b-row class="mt-5 mb-5 pb-5">
        <b-col>
          <Signatures :signedName="signedName" :signedCountry="signedCountry" :signedComment="signedComment"></Signatures>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
import Signatures from '../components/widgets/Signatures';
import SocialShare from './widgets/SocialShare'
export default {
  name: 'thanks',
  components: {
    SocialShare,
    Signatures
  },
  props: [
    'signedName', // the just signed details to display at top
    'signedCountry',
    'signedComment'
  ],
  // mounted () {
  //   console.log('thanks / signedName', this.signedName);
  // }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/thanks.vue